import { Container, Paper, Popper } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { TextButton } from '../Button';

import { IconButton, CrossIcon } from '../index';
import { Input } from '../Input';

import { StyledTag } from './style';

export const Tag = ({ onClick, disabled, children, ...rest }) => {
    return (
        <StyledTag
            {...rest}
            disabled={disabled}
            onClick={disabled || !onClick ? () => {} : (e) => onClick(e)}
        >
            {children}
        </StyledTag>
    );
};

Tag.propTypes = {
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    rest: PropTypes.object,
    children: PropTypes.any,
};

export const TagDetail = ({
    data,
    anchorEl,
    placement,
    popperStyle,
    onSave,
    onClose,
    onDelete,
}) => {
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popper' : undefined;
    const [inputValue, setInputValue] = useState('');

    useEffect(() => {
        if (data) {
            setInputValue(data);
        } else {
            setInputValue('');
        }
    }, [data]);

    const onClickCancel = (e) => {
        e.stopPropagation();
        setInputValue('');
        onClose();
    };

    const onClickSave = (e) => {
        e.stopPropagation();
        onSave(inputValue);
        onClickCancel(e);
        setInputValue('');
    };

    const onClickDelete = (e) => {
        e.stopPropagation();
        onDelete(inputValue);
        setInputValue('');
    };

    return (
        <div>
            <Popper
                id={id}
                open={open}
                anchorEl={anchorEl}
                placement={placement}
                style={popperStyle}
            >
                <Paper
                    elevation={0}
                    variant="outlined"
                    style={{
                        position: 'relative',
                        height: '135px',
                        width: '320px',
                        borderRadius: '20px',
                        paddingBottom: '24px',
                        borderColor: '#D2D6E9',
                    }}
                >
                    <Container
                        style={{
                            position: 'absolute',
                            display: 'flex',
                            paddingTop: '5px',
                            paddingRight: '9px',
                            marginRight: '2px',
                        }}
                    >
                        <IconButton
                            style={{ marginLeft: 'auto' }}
                            onClick={(e) => onClickCancel(e)}
                        >
                            <CrossIcon width="24px" height="24px" fill="black" />
                        </IconButton>
                    </Container>
                    <Container style={{ position: 'absolute', top: '24px' }}>
                        <Input
                            id="addTag"
                            label="Tag name"
                            $inputMaxWidth="640px"
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                            style={{ height: '21px', width: '271px' }}
                            max={20}
                        />
                    </Container>
                    <Container style={{ display: 'flex', paddingTop: '90px' }}>
                        {!data ? (
                            <TextButton
                                width="24px"
                                height="32px"
                                $color="gray2"
                                $noShadow
                                style={{ marginLeft: 'auto' }}
                                onClick={(e) => onClickCancel(e)}
                            >
                                Cancel
                            </TextButton>
                        ) : (
                            <TextButton
                                width="24px"
                                height="32px"
                                $color="gray2"
                                $noShadow
                                style={{ marginRight: 'auto' }}
                                onClick={(e) => onClickDelete(e)}
                            >
                                Delete
                            </TextButton>
                        )}

                        <Tag
                            style={{ marginLeft: '25px' }}
                            onClick={(e) => onClickSave(e)}
                            disabled={!inputValue}
                        >
                            Save
                        </Tag>
                    </Container>
                </Paper>
            </Popper>
        </div>
    );
};

TagDetail.propTypes = {
    data: PropTypes.string,
    anchorEl: PropTypes.bool,
    placement: PropTypes.string,
    popperStyle: PropTypes.object,
    onSave: PropTypes.func,
    onClose: PropTypes.func,
    onDelete: PropTypes.func,
};
